const domain = "view";
const extendedViewCleanDelay = 6e5;
const schemaIdKey = "id";
export {
  domain,
  extendedViewCleanDelay,
  schemaIdKey
};
//# sourceMappingURL=types.js.map
